export const checkLineNumber = (textBlock: HTMLParagraphElement | null, text: string) => {
  if (!textBlock || !text) return 0;

  const originalStyle = textBlock.style.display;
  const originalText = textBlock.textContent || "";

  textBlock.style.display = "block";
  textBlock.innerText = text;

  const computedStyle = window.getComputedStyle(textBlock);
  const lineHeight = parseFloat(computedStyle.lineHeight);
  const height = textBlock.clientHeight;
  const numberOfLines = Math.floor(height / lineHeight);

  textBlock.style.display = originalStyle;
  textBlock.textContent = originalText;

  return numberOfLines;
};
